import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { ExternalIntegration } from "types/generated";
import SpacePath from "components/SpacePath";

const BackstageIntegrationTableSpaceCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath
        spaceId={integration.spaceDetails.id}
        fallbackName={integration.spaceDetails.name}
      />
    </TableSimpleCell>
  );
};

export default BackstageIntegrationTableSpaceCell;
